import React, { ReactElement, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../../../../store/store';
// import { useGetListPostQuery } from '../../../../services/api/apiProvider';
import { OptionGlobal } from '../../../../common/constants/globalConstants';
import { Spinner } from 'react-bootstrap';
import { ImageCustom } from '../../../../common/components/ImageCustom';
import './TimelineProfile.scss';
import TimelineDetailModal from '../TimelineModal/TimelineDetailModal';
import { ResponsePostTimeline } from '../../../../services/api/models/response/responseTimeline';
import { useGetListPostMutation } from '../../../../services/api/apiProvider';
import InfiniteScroll from 'react-infinite-scroll-component';

const TimelineProfile = (): ReactElement => {
  const { userData } = useSelector((state: AppState) => state.profilePageState);
  const [option, setOption] = useState<OptionGlobal>({
    numOfPage: 0,
    numInPage: 10,
  });
  const [isShowModal, setIsShowModal] = useState<boolean>(false);
  const [timelinePost, setTimelinePost] = useState<ResponsePostTimeline>();
  const [listPost, setListPost] = useState<ResponsePostTimeline[]>([]);

  const [getListPost, result] = useGetListPostMutation();
  useEffect(() => {
    fetchListPostData();
  }, []);

  const fetchListPostData = async () => {
    const data = await getListPost({
      userId: userData?.user.id,
      numOfPage: option.numOfPage,
      numInPage: option.numInPage,
    }).unwrap();
    if (data) {
      setListPost(data);
    }
  };
  const fetchMoreData = async () => {
    const newOption: OptionGlobal = {
      numOfPage: option.numOfPage + 1,
      numInPage: option.numInPage + 10,
    };
    const data = await getListPost({
      userId: userData?.user.id,
      numOfPage: newOption.numOfPage,
      numInPage: newOption.numInPage,
    }).unwrap();
    if (data) {
      const newList = listPost.concat(data);
      setListPost(newList);
      setOption(newOption);
    }
  };

  const handleShowDetailPost = async (post: ResponsePostTimeline) => {
    setIsShowModal(true);
    setTimelinePost(post);
  };
  const handleCloseDetailPostModal = (child: boolean) => {
    setIsShowModal(child);
    setTimelinePost(undefined);
  };

  const renderList = () => {
    if (listPost) {
      return (
        <>
          <InfiniteScroll
            dataLength={listPost.length}
            next={fetchMoreData}
            hasMore={true}
            loader={
              result.isLoading && (
                <div className="block-group__loading">
                  <Spinner
                    animation="border"
                    style={{ color: 'var(--color-primary)' }}
                  />
                </div>
              )
            }
          >
            {listPost.map((post) => (
              <div
                onClick={() => handleShowDetailPost(post)}
                key={post.id}
                className="timeline-profile-image"
              >
                <ImageCustom src={post.media.uri} />
              </div>
            ))}
          </InfiniteScroll>
        </>
      );
    }
  };
  return (
    <div className="timeline-profile-root">
      {renderList()}
      {timelinePost && (
        <TimelineDetailModal
          post={timelinePost}
          isShow={isShowModal}
          callBackClose={handleCloseDetailPostModal}
        />
      )}
    </div>
  );
};
export default TimelineProfile;
